export default __webpack_public_path__ + "static/media/benefit_2@2x.e9cc0221.png";